import { render, staticRenderFns } from "./Editor-FlagPill.vue?vue&type=template&id=d18e2960&scoped=true"
import script from "./Editor-FlagPill.vue?vue&type=script&lang=ts"
export * from "./Editor-FlagPill.vue?vue&type=script&lang=ts"
import style0 from "./Editor-FlagPill.vue?vue&type=style&index=0&id=d18e2960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18e2960",
  null
  
)

export default component.exports